import React, { Component } from 'react';
import styled from 'styled-components';

import AnimationContainer from '../../common/FadeAnimation';
import Headline from '../../common/Headline';
import Content from '../../common/Content';

import Color from '../../utils/colors';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import chtpz from './assets/chtpz.svg';
import delivery from './assets/delivery.svg';
import mts from './assets/mts.svg';
import okko from './assets/okko.svg';
import otkritie from './assets/otkritie.svg';
import sber from './assets/sber.svg';
import mail from './assets/mail.svg';
import teledva from './assets/teledva.svg';

class Clients extends Component {
    render() {
        const { className } = this.props;
        const clientsList = [sber, okko, delivery, teledva, otkritie, chtpz, mts, mail];

        return (
            <Root className={className}>
                <ContentStyled>
                    <AnimationContainer external="parent">
                        <HeadlineStyled>
                            Клиенты
                        </HeadlineStyled>
                    </AnimationContainer>
                    <AnimationContainer external="parent" delay={250}>
                        <ClientsContainer>
                            {clientsList.map((client, index) => (
                                <ClientBlock key={index.toString()}>
                                    <Image src={client} />
                                </ClientBlock>
                            ))}
                        </ClientsContainer>
                    </AnimationContainer>
                </ContentStyled>
            </Root>
        );
    }
}

const Root = styled.div`
    width: 100%;
    padding-top: 64px;
    padding-bottom: 66px;

    background: ${Color.PRIMARY};

    ${mediaWidth.m} {
        padding-top: 96px;
        padding-bottom: 96px;
    }
`;

const ContentStyled = styled(Content)``;

const ClientsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 48px 0px;

    margin-top: 40px;

    ${mediaWidth.m} {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 53px 0px;

        margin-top: 56px;
    }

    ${mediaWidth.l} {
        grid-gap: 72px 30px;

        margin-top: 64px;
    }

    ${mediaWidth.xl} {
        grid-gap: 80px 0px;
    }
`;

const ClientBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

const Image = styled.img`
    display: block;

    height: 39px;

    ${mediaWidth.m} {
        width: 144px;
    }

    ${mediaWidth.l} {
        width: 206px;
        height: 55px;
    }

    ${mediaWidth.xl} {
        width: 219px;
        height: 55px;
    }
`;

const HeadlineStyled = styled(Headline)`
    font-size: 32px;
    line-height: 32px;

    ${mediaWidth.m} {
        font-size: 48px;
        line-height: 48px;
    }

    ${mediaWidth.l} {
        font-size: 32px;
        line-height: 32px;
    }
`;

export default Clients;
